/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FollowingRefetchWrapper_user$ref = any;
type Recommendations_trending$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FollowingContainer_viewer$ref: FragmentReference;
export type FollowingContainer_viewer = {|
  +user?: ?{|
    +$fragmentRefs: FollowingRefetchWrapper_user$ref
  |},
  +$fragmentRefs: Recommendations_trending$ref,
  +$refType: FollowingContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FollowingContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Recommendations_trending",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FollowingRefetchWrapper_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cc737ef1358a6979cd16475e2e7bcf86';
module.exports = node;
